import routerOptions0 from "/home/stcomuser/htdocs/satyatunes.com/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  strict: false,
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}